import { Link } from "react-router-dom";
import SEO from "@components/SEO";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <SEO
        title="Page Not Found | Ikhlas Tours"
        description="The page you are looking for does not exist. Browse our New Zealand tour packages or return to the home page."
        noIndex
      />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-16">
        <p className="text-sm font-semibold text-primary uppercase tracking-wide mb-3">
          404
        </p>
        <h1 className="text-4xl md:text-5xl font-bold text-primaryText mb-4">
          Page not found
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-block bg-primary text-white px-6 py-3 rounded-md font-semibold hover:bg-opacity-90 transition-colors"
          >
            Back to home
          </Link>
          <Link
            to="/tours"
            className="inline-block bg-white border border-primary text-primary px-6 py-3 rounded-md font-semibold hover:bg-gray-50 transition-colors"
          >
            Browse tours
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
